import { render, staticRenderFns } from "./skeletonLoading.vue?vue&type=template&id=56c0be10&"
import script from "./skeletonLoading.vue?vue&type=script&lang=js&"
export * from "./skeletonLoading.vue?vue&type=script&lang=js&"
import style0 from "./skeletonLoading.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports